import './draft-source-notice.css';
export default function DraftSourceNotice({review}:{review:any}) {
 if(!review)return null;
 const excluded=Number(review.excluded_stays)||0;
 return <div role="status" className="draft-source-notice">
  {excluded>0?<><strong>Calcul partiel — sources à vérifier</strong><p>{excluded} séjour(s) exclus du montant proposé. Ce montant ne constitue pas un total fiscal complet. Vérifiez les justificatifs avec l’ONT avant de déclarer.</p></>:<p>Estimation répartie selon les nuitées de chaque mois.</p>}
  {Number(review.provisional_stays)>0&&<p>{review.provisional_stays} séjour(s) repris à partir du montant HT enregistré, sous réserve de contrôle.</p>}
  {Array.isArray(review.excluded)&&review.excluded.length>0&&<details><summary>Séjours à vérifier</summary><ul>{review.excluded.map((stay:any)=><li key={stay.checkin_id}>{stay.reference||'Fiche sans référence'} — {stay.currency}</li>)}</ul></details>}
 </div>;
}
